module.exports = __webpack_public_path__ + "static/img/202110.8ea8346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/202110.png
// module id = UmZM
// module chunks = 0